import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectDetailsPageSubprojectsPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import SubprojectsDataCollection from 'modules/project_management/components/tables/SubprojectsDataCollection'
import SubprojectsPanel from 'modules/project_management/components/tables/SubprojectsDataCollection/SubprojectsPanel'

import { ISubprojectsPanelData } from './types'

const SubprojectsPage = () => {
  const { id } = useParams()
  const projectId = Number(id)
  const { data } = useQuery(ProjectManagementProjectDetailsPageSubprojectsPageDocument, {
    variables: { projectId },
  })

  const project = data?.projectManagement.project

  const [showSubprojectsPanel, setShowSubprojectsPanel] = useState<boolean>(false)
  const [subprojectPanelData, setSubprojectPanelData] = useState<ISubprojectsPanelData>({
    inputedMinutes: 0,
    subprojectId: 0,
    laborCostCents: null,
    subprojectName: '',
  })

  useEffect(() => {
    track(trackingEvents.projectManagement.subprojects.goToProjectDetailsSubproject)
  }, [])

  const canSeeCosts = project?._policies?.seeCost.can ?? false
  const canSeeLaborCosts = project?._policies?.seeLaborCost.can ?? false

  const projectCurrency = project?.legalEntity.currency || 'EUR'

  const canManageProjects = data?.projectManagement._policies.projectManage.can ?? false
  const canManageSubprojects = project?._policies?.assignEditor.can ?? false

  const hasTimeTrackingSection =
    data?.attendance._policies.sidebarSeeAttendanceCompanyTopLevelItem.can ?? false

  const openSidePanel = (sidePanelData: ISubprojectsPanelData) => {
    setShowSubprojectsPanel(true)
    setSubprojectPanelData(sidePanelData)

    track(trackingEvents.projectManagement.subprojects.openSubprojectDetails, {
      project_id: projectId,
      subproject_id: sidePanelData.subprojectId,
    })
  }

  return (
    <Box gap="s24">
      <SubprojectsDataCollection
        projectId={projectId}
        canExportData={canManageProjects && hasTimeTrackingSection}
        canManageSubprojects={canManageSubprojects}
        canSeeCosts={canSeeCosts}
        projectCurrency={projectCurrency}
        onClick={openSidePanel}
      />

      <SubprojectsPanel
        onClose={() => setShowSubprojectsPanel(false)}
        showSubprojectsPanel={showSubprojectsPanel}
        projectId={projectId}
        projectCurrency={projectCurrency}
        canSeeLaborCosts={canSeeLaborCosts}
        subprojectPanelData={subprojectPanelData}
      />
    </Box>
  )
}

export default SubprojectsPage
